// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';

type Props = {
  width?: number;
  fill?: string;
};
export const Copy = ({ fill = 'none', width = 11 }: Props) => {
  const { colorMode } = useColorMode();
  const fillColor = colorMode === 'light' ? 'black' : 'white';
  return (
    <chakra.svg
      width={`${width}px`}
      height={`${width + 1}px`}
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
    >
      <path
        d="M3.20824 3.24984V1.87484C3.20824 1.62171 3.41345 1.4165 3.66658 1.4165H9.16657C9.41971 1.4165 9.62491 1.62171 9.62491 1.87484V8.2915C9.62491 8.54464 9.41971 8.74984 9.16657 8.74984H7.79157V10.1244C7.79157 10.3778 7.58537 10.5832 7.33013 10.5832H1.83639C1.58152 10.5832 1.375 10.3794 1.375 10.1244L1.37619 3.70857C1.37624 3.45522 1.58246 3.24984 1.83765 3.24984H3.20824ZM2.29278 4.1665L2.29175 9.6665H6.87491V4.1665H2.29278ZM4.12491 3.24984H7.79157V7.83317H8.70824V2.33317H4.12491V3.24984Z"
        fill={fillColor}
        fillOpacity="0.6"
      />
    </chakra.svg>
  );
};
